import React, { Component } from 'react';
import "../../assets/scss/project/project-hero.scss"
import { Container } from 'react-bootstrap';
import variables from "../../assets/scss/variables.module.scss";
import { LazyLoadImage } from 'react-lazy-load-image-component';
import 'react-lazy-load-image-component/src/effects/blur.css';

interface props {
    hero: string;
    placeholder?: string;
    // children: Array<JSX.Element>;
}


class ProjectHero extends Component<props> {
    componentDidMount() {
        document.body.style.backgroundColor = variables.colorProjectBg;
    }

    render() {
        return (
            <div className="hero-image-container" >
                <LazyLoadImage className="hero-image-cover" wrapperClassName="hero-image-lazy" effect="blur" src={this.props.hero} placeholderSrc={this.props.placeholder} />
            </div>

        );
    }
}

export default ProjectHero;